'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SamlId$() {
  this.caT = null;
  this.caU = false;
}
export { $c_Lpresto_types$SamlId$ as $c_Lpresto_types$SamlId$ };
$p = $c_Lpresto_types$SamlId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SamlId$;
/** @constructor */
function $h_Lpresto_types$SamlId$() {
}
export { $h_Lpresto_types$SamlId$ as $h_Lpresto_types$SamlId$ };
$h_Lpresto_types$SamlId$.prototype = $p;
$p.cHM = (function() {
  if ((!this.caU)) {
    this.caT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.caU = true;
  }
  return this.caT;
});
var $d_Lpresto_types$SamlId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SamlId$, "presto.types$SamlId$", ({
  a1q: 1,
  D: 1
}));
export { $d_Lpresto_types$SamlId$ as $d_Lpresto_types$SamlId$ };
var $n_Lpresto_types$SamlId$;
function $m_Lpresto_types$SamlId$() {
  if ((!$n_Lpresto_types$SamlId$)) {
    $n_Lpresto_types$SamlId$ = new $c_Lpresto_types$SamlId$();
  }
  return $n_Lpresto_types$SamlId$;
}
export { $m_Lpresto_types$SamlId$ as $m_Lpresto_types$SamlId$ };
//# sourceMappingURL=presto.types$-Saml-Id$.js.map
